import { TypePolicies } from '@apollo/client';
import { Address } from './address';
import { Person } from './person';
import { Project } from './project';
import { Query } from './query';
import { StandardTemplateMilestone } from './standardTemplateMilestone';
import { Task } from './task';

import { ApiFile } from './apiFile';
import { AuditLogEvent } from './auditLogEvent';
import { ClientReport } from './clientReport';
import { Comment } from './comment';
import { DailyReport } from './dailyReport';
import { Decision } from './decision';
import { Document } from './document';
import { Folder } from './folder';
import { Incident } from './incident';
import { Inspection } from './inspection';
import { Installation } from './installation';
import { MaterialDelivery } from './materialDelivery';
import { MetaDelivery } from './metaDelivery';
import { MetaInspection } from './metaInspection';
import { MetaMilestone } from './metaMilestone';
import { Milestone } from './milestone';
import { Mutation } from './mutation';
import { OnSiteWorkEvent } from './onSiteWorkEvent';
import { Plan } from './plan';
import { PlanSet } from './planSet';
import { PlanVersion } from './planVersion';
import { Subscription } from './subscription';


export const typePolicies: TypePolicies = {
  ApiFile,
  Address,
  Person,
  Project,
  Query,
  Mutation,
  Document,
  ClientReport,
  DailyReport,
  Task,
  Folder,
  OnSiteWorkEvent,
  StandardTemplateMilestone,
  Incident,
  Inspection,
  Installation,
  Decision,
  MaterialDelivery,
  MetaMilestone,
  MetaDelivery,
  MetaInspection,
  Plan,
  PlanVersion,
  PlanSet,
  Milestone,
  Comment,
  AuditLogEvent,
  Subscription
};
